<template>
  <div :id="$style.title" :style="styles">
    <h2>{{ main_title }}</h2>
    <small>{{ sub_title }}</small>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "MainTitle",
  props: {
    /* 指定することできる引数 */
    // メインタイトル
    main_title: {
      type: String,
      default: "MainTitle"
    },
    // メインタイトルの下に付くサブタイトル
    sub_title: {
      type: String,
      default: ""
    },
    // 文字の色
    color: {},
    // 文字のポジション`left` or `center` or `right`
    align: {},
    // タイトルの位置指定 absolute or relative
    position: {},
  },

  computed: {
    styles() {
      return {
        "--color": this.color,
        "--align": this.align
      };
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #title {
    --color: #000;
    --align: right;
    text-align: var(--align);
    color: var(--color);
    h2 {
      margin: 0;
      font-size: 20px;
    }
    small {
      font-size: 14px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #title {
    --color: #000;
    --align: right;
    text-align: var(--align);
    color: var(--color);
    h2 {
      margin: 0;
      font-size: 26px;
    }
    small {
      font-size: 17px;
    }
  }
}
/* for Microsoft Edge */
@supports (-ms-ime-align: auto) {
  #title {
    text-align: center;
  }
}
</style>
